import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NbRoleProvider } from '@nebular/security';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApplicationsService } from '~core/data/applications.service';
import { Application } from '~core/models/application.model';
import { Roles } from '~core/models/roles.model';
import { UserSettingsService } from '~core/utils/user-settings.service';

@Component({
  selector: 'idl-developer-apps-card',
  templateUrl: './developer-apps-card.component.html',
  styleUrls: ['./developer-apps-card.component.scss']
})
export class DeveloperAppsCardComponent implements OnDestroy {
  private unsubscribe$ = new Subject<void>();

  displayedColumns: string[] = ['name', 'description'];

  dataSource = new MatTableDataSource<Application>();

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  applications: Application[];
  appFavs: number[] = [];

  constructor(
    private developerAppsService: ApplicationsService,
    private router: Router,
    private roleProvider: NbRoleProvider,
    private _userSettingsService: UserSettingsService
  ) {
    this.roleProvider
      .getRole()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(response => {
        let roles: string[];
        // Admin and SU pass no roles to api
        if (
          response.includes(Roles[Roles.Administrator]) ||
          response.includes(Roles[Roles.SuperUser])
        ) {
          roles = null;
        } else {
          roles = [Roles[Roles.Manager], Roles[Roles.Developer]];
        }

        this.developerAppsService
          .list(roles)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(applications => {
            // console.log(data);

            this._userSettingsService
              .getSettings()
              .pipe(takeUntil(this.unsubscribe$))
              .subscribe(settings => {
                if (settings.appFavourites) {
                  this.appFavs = settings.appFavourites;
                }
                this.applications = applications.filter(
                  app =>
                    this.appFavs.findIndex(id => id === app.applicationId) >= 0
                );

                this.dataSource = new MatTableDataSource(this.applications);
                setTimeout(() => {
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;
                });
              });
          });
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onRowClick(event): void {
    this.router.navigate(['/applications', event.applicationId]);
  }
}
